import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Provider } from "react-redux";

import HTTPService from "./services/http";
import store from "./store";

import "./assets/css/index.css";
import "./assets/css/global.scss";
import "antd/dist/antd.css";

import AppRoute from "./routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-loading-skeleton/dist/skeleton.css";
import "./App.css";
import WakeStatusOverlay from "./components/wake-status-overlay";

global.services = {
  http: HTTPService,
};

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <GoogleOAuthProvider clientId="730177063206-0s2buijcp6fo3ucnfnbg00kjaqi9iboe.apps.googleusercontent.com">
        <BrowserRouter>
          <Route component={AppRoute} />
        </BrowserRouter>
        <ToastContainer autoClose={2000} />
        <WakeStatusOverlay />
      </GoogleOAuthProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
reportWebVitals();
